<template>
  <div class="epicrisis-pattern">
    <button type="button" class="btn btn-success" @click="initData(); showModal = !showModal">
      <font-awesome-icon icon="copy"/>
      {{ t('Pattern') }}
    </button>

    <b-modal class="epicrisis-modal"
      :hide-footer="hideFooter"
      :title="t('Epicrisis pattern')"
      v-model="showModal"
      scrollable
    >
      <div class="text-center p-4" v-if="loading === true">
        <loading size="xs"/>
        {{ t('Loading patterns') }}
      </div>
      <div class="epicrisis-list text-justify" v-if="loading === false">
        <div v-if="items.length">
          <div class="pt-2 pb-2 pl-3 pr-3"><h2 class="h3 mb-0">{{ t('First applications') }}</h2></div>
          <div class="epicrisis-list-item" v-for="item in items" v-if="item.newApplication === true">
            <div class="description" :class="{'closed': showDetails !== item.id}" v-html="item.name"></div>
            <div class="button-list">
              <button type="button"
                class="btn btn-success btn-sm mt-2"
                @click="showModal = false; $emit('select', item)"
              >
                <font-awesome-icon icon="check"/>
                {{ t('Select') }}
              </button>
            </div>
          </div>
          <div class="pt-4 pb-2 pl-3 pr-3"><h2 class="h3 mb-0">{{ t('Other applications') }}</h2></div>
          <div class="epicrisis-list-item" v-for="item in items" v-if="item.newApplication === false">
            <div class="description" :class="{'closed': showDetails !== item.id}" v-html="item.name"></div>
            <div class="button-list">
              <button type="button"
                class="btn btn-success btn-sm mt-2"
                @click="showModal = false; $emit('select', item)"
              >
                <font-awesome-icon icon="check"/>
                {{ t('Select') }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="items.length == 0">{{ t('We did not find any patters for selected drug/indication.') }}</div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import Loading from '../../../core/Components/loading'

  export default {
    components: {
      Loading,
    },
    props: {
      applicationId: {
        type: String | Number,
        required: true,
      },
    },
    methods: {
      initData() {
        this.loading = true
        this.$store.dispatch('codeBook/loadEpi', this.applicationId).then(res => {
          this.loading = false
          this.items = res.epicrisis
        }).catch(error => {
          this.loading = false
        })
      },
    },
    data() {
      return {
        items: [],
        showDetails: null,
        showModal: false,
        hideFooter: true,
        loading: true,
      }
    },
  }
</script>
<style lang="scss">
  .epicrisis-pattern {
    button {
      border-radius: 0 .25rem .25rem 0;
      height: 100%;
    }
  }

  .epicrisis-modal {
    font-weight: normal ! important;
    font-size: 15px ! important;

    .modal-body {
      padding: 0;
    }

    .epicrisis-list {

      .epicrisis-list-item {
        padding: 15px 15px 10px;
      }

      .epicrisis-list-item:not(:first-child) {
        /*margin-top: 10px;*/
        padding-top: 10px;
        border-top: 1px solid #e2e5e9;
      }

      .button-list {
        margin-top: -5px;
        z-index: 2;
        position: relative;
      }

      .description {
        line-height: 22px;
        position: relative;

        /*&.closed {*/
        /*overflow-y: hidden;*/
        /*height: 50px;*/

        /*&:after {*/
        /*content: ' ';*/
        /*position: absolute;*/
        /*z-index: 1;*/
        /*bottom: 0;*/
        /*left: 0;*/
        /*right: 0;*/
        /*height: 40px;*/
        /*background: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);*/
        /*background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);*/
        /*background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);*/
        /*}*/
        /*}*/
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/private/applications/epicrisis-pattern.vue